<template>
  <div id="popup-wrap">
    <van-popup v-model="dialogVisible" class="popup-wrap">
      <div class="popup-box">
        <div class="popup-header">
          <div class="popup-title">消息模板同步提示</div>
          <img src="../../../../../assets/img/h5/official/home_icon_cross.png" @click="handleClose"/>
        </div>
        <div class="popup-content">
          <iframe :src="syncTemplateLink" frameborder="0" width="100%" height="370px"></iframe>
        </div>
        <div class="btn-wrap">
          <div class="sure-btn" @click="dialogVisible = false">确定</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { getPlatformUuid } from '@/utils/auth'
  export default {
    name: "SyncTemplate",
    components: {
    },
    props: {},
    created() {},
    data: function () {
      return {
        dialogVisible: false, //弹出框
        syncTemplateLink: process.env.VUE_APP_MOVIE_DOMAIN +'movie/api/template/addOneTemplate?platformUUID='+getPlatformUuid()
      }
    },
    methods: {
      init: function () {
        this.dialogVisible = true;
        this.$Message.success('正在同步模板消息')
      },
      handleClose:function(){
        this.dialogVisible = false;
      }
    }
  }
</script>

<style scoped>
  .color-666{
    color: #666666;
  }
  .color-222{
    color: #222222;
  }
  .font-weight-bold{
    font-weight: bold;
  }
  .text-right{
    text-align: right;
  }
  .padding-5{
    padding: 5px;
  }
  .padding-tb-10{
    padding: 10px 0
  }
  .margin-top-10{
    margin-top: 10px;
  }
  .normal-font {
    color: #FF4F76;;
    font-size: 14px;
  }
  .form-wrapper .explain{
    font-family: Alibaba-PuHuiTi-R;
    font-size: 13px;
    color: #FF4F76;
    line-height: 20px;
    background: #FFFFFF;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  .form-wrapper .explain .explain-title{
    font-family: Alibaba-PuHuiTi-M;
    min-width: 45px;
  }
  .form-wrapper .explain .explain-tip{
    font-family: Alibaba-PuHuiTi-R;
    color: #999999;
  }
  .form-wrapper .part-div{
    background: #FAFAFA;
    border-radius: 4px;
  }
  .form-wrapper .part-div .img-wrap{
    margin: 20px;
  }
  .form-wrapper .part-div .img-left{
    margin: 20px 20px 20px 35px;
  }
  .form-wrapper .part-div .img-right{
    margin: 20px 35px 20px 20px;
  }
  .form-wrapper .part-div .img-wrap .img-box{
    background: #FFFFFF;
  }
  .form-wrapper .part-div .img-wrap .img-box img{
    width: 100%
  }
  .form-wrapper .part-div .step-btn{
    background-image: linear-gradient(90deg, #FFBB47 6%, #FF8622 89%, #FF8622 89%);
    border-radius: 17px;
    color: #FFFFFF;
    font-family: Alibaba-PuHuiTi-R;
    font-size: 16px;
    padding: 3px 15px;
  }
  .form-wrapper .part-div .step-tip{
    font-family: Alibaba-PuHuiTi-M;
    font-size: 14px;
    color: #222222;
    padding-top: 20px;
  }
  .form-wrapper .part-div .step-tip .sync{
    font-family: Alibaba-PuHuiTi-R;
    font-size: 14px;
    color: #FF4F76;
    padding:5px 15px;
    border:1px solid #FF4F76;
    margin-left: 10px;
    cursor: pointer;
  }
  >>>.v-transfer-dom .v-modal{
    z-index: 0 !important;
  }
  >>>.v-transfer-dom .ivu-message{
    z-index: 9999 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/official/authorization/modal/SyncTemplateInfo.vue